import { ActionHandler } from '../../../common/actions/core/action-handler';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { Action } from '../../../common/actions/core/action';
import { OpenDoubleOptWarningDialogAction } from './double-opt-warning-dialog.action';
import { PackageThumbnail } from '../../../common/services/package/package.model';

/*@ngInject*/
export default class OpenDoubleOptWarningDialogController
  implements ActionHandler {
  private dialogElement;
  protected package: PackageThumbnail;
  protected approve : () => void;
  private description:string;

  constructor(
    protected $element,
    private $translate,
    private $sce,
    protected actionDispatcher: ActionDispatcherService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#double-opt-warning-dialog').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenDoubleOptWarningDialogAction) {
      this.package = action.relatedPackage;
      this.approve = action.approve;
      this.description = action.description;
      this.openDialog();
    }
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onApprove(){
    this.approve();
    this.dialogElement.close();
  }

  public onCancel() {
    this.dialogElement.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/double-opt-dialog/warning/double-opt-warning-dialog.controller.ts